import createKeyFactory, { FactoryQueryParams, KEYS } from 'utils/createKeyFactory';

const tradeListFactory = {
  ...createKeyFactory([KEYS.TRADE_LIST]),
  myFriendList: (userId?: string, params?: FactoryQueryParams) => [
    ...tradeListFactory.all(),
    'myFriendsList',
    ...tradeListFactory.list(params),
    ...(userId ? [userId] : []),
  ],
  myRequests: (params?: FactoryQueryParams) => [
    ...tradeListFactory.all(),
    'myRequests',
    ...tradeListFactory.list(params),
  ],
};

export default tradeListFactory;
